/**
 * Quando uma caixa de e-mail está pronta para usar (listar, enviar, aparecer nos seletores).
 *
 * Antes era `is_connected && grant_id`: o grant é do Nylas. Caixa que nasce no EmailEngine
 * (`mail_provider = 'emailengine'`, migração em docs/specs/migracao-nylas-emailengine.md) não tem
 * grant — sem isto ela aparecia como "Conta pendente" e nenhuma tela a usava (visto em 22/10/2026).
 */
export interface MailAccountConnectionFields {
  is_connected?: boolean | null;
  grant_id?: string | null;
  mail_provider?: string | null;
}

export function isMailAccountUsable(acc: MailAccountConnectionFields): boolean {
  return !!acc.is_connected && (!!acc.grant_id || acc.mail_provider === 'emailengine');
}

/**
 * Valor para os lugares que guardam um "grantId" da conta só para saber se ela está conectada
 * (AccountDropdown): o grant do Nylas ou um marcador para conta do EmailEngine.
 */
export function accountConnectionRef(acc: MailAccountConnectionFields): string | null {
  return acc.grant_id || (acc.mail_provider === 'emailengine' ? 'emailengine' : null);
}
